import { render } from "./PositionsTable.vue?vue&type=template&id=d007bafc&scoped=true"
import script from "./PositionsTable.vue?vue&type=script&lang=js"
export * from "./PositionsTable.vue?vue&type=script&lang=js"

import "./PositionsTable.vue?vue&type=style&index=0&id=d007bafc&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d007bafc"]])

export default __exports__